<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      list: [
        {
          title: 'ПТС транспортного средства',
          text: '',
          url: '/public/images/pages/vikup/image-30.png',
        },
        {
          title: 'СТС транспортного средства',
          text: '',
          url: '/public/images/pages/vikup/image-31.png',
        },
        {
          title: 'Паспорт собственника авто',
          text: '',
          url: '/public/images/pages/vikup/image-32.png',
        },
        {
          title: 'Генеральная довереность',
          text: '(при необходимости)',
          url: '/public/images/pages/vikup/image-33.png',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    openPopup() {
      this.togglePopup('order-call-with-message');
      this.addTitlePopup('<span>Подать</span> заявку на выкуп');
    },
  },
};
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <h2 class="title-h2 mb-6">Какие документы нужны для&nbsp;выкупа</h2>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-5">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="relative flex items-center flex-row sm:flex-col bg-white rounded-big-brand px-8 sm:px-4 py-4 cursor-pointer transition ease-in-out duration-200 hover:shadow-brand"
          @click="openPopup"
        >
          <div class="flex mr-2 sm:mr-0 mb-2">
            <div class="relative mx-auto">
              <div
                v-html="'0' + (index + 1)"
                class="absolute top-0 -left-4 text-2xl sm:text-4xl font-medium"
              ></div>
              <img
                :src="item.url"
                alt=""
                class="relative z-1 w-full max-w-[100px] sm:max-w-[130px] h-auto"
              >
            </div>
          </div>
          <div class="flex flex-col sm:mt-auto">
            <p
              class="text-center font-medium text-gray-700"
              v-html="item.title"
            ></p>
            <p
              class="text-center text-sm text-gray-500 leading-7"
              v-html="item.text ? item.text : '&nbsp;'"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
